/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentProject_Projects.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Project API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, June 15, 2019 - 01:06:32 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      06/15/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Project_Projects = {
    all: (companyid, parentid) => requests.get(`/Projects?companyid=${companyid}&parentid=${parentid}`),
    get: projectid => requests.get(`/Project/${projectid}`),
    create: project => requests.post(`/Projects`, project),
    update: (projectid, project) => requests.put(`/Project/${projectid}`, project),
    delete: projectid => requests.del(`/Project/${projectid}`),
};

export const Project_ProjectPath = {
    get: parentid => requests.get(`/ProjectPath?parentid=${parentid}`),
}

export const Project_ProjectTree = {
    get: (companyid, parentid) => requests.get(`/ProjectTree?companyid=${companyid}&parentid=${parentid}`),
}




// WEBPACK FOOTER //
// ./src/agents/agentProject_Projects.js